import { Subscription, ReplaySubject } from 'rxjs';
import { Publication, CustomField } from './../interfaces/publication';
import { PublicationService } from './publication.service';
import { Injectable, OnDestroy } from '@angular/core';


@Injectable()
export class CustomFieldsService implements OnDestroy {
	publication: Publication;
	subscriptions: Subscription = new Subscription();
	mediaclipCustomFields: ReplaySubject<CustomField[]> = new ReplaySubject<CustomField[]>(1);

	constructor(private publicationService: PublicationService) {
		this.publication = {} as Publication;
		this.subscriptions.add(this.publicationService.getData().subscribe((publicationData: Publication) => {
			this.publication = publicationData;
			let customFields: CustomField[] = [];
			if (this.publication && this.publication.customfields) {
				if (this.publication.customfields.hasOwnProperty('mediaclip')) {
					customFields = this.publication.customfields.mediaclip;
				}
			}
			this.mediaclipCustomFields.next(customFields);
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	getCustomFields(entityType: string) {
		return this.publication && this.publication.customfields && this.publication.customfields[entityType];
	}

	getCustomField(entityType: string, fieldName: string) {
		for (let i = 0; i < this.publication?.customfields?.[entityType].length; i++) {
			if (this.publication.customfields[entityType][i].name === fieldName) {
				return this.publication && this.publication.customfields && this.publication.customfields[entityType][i];
			}
		}
	}
}
